import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { WidgetTableColumn } from 'jamespot-user-api';

import { JRCButton, JRCIcon, JRCModalContent, JRCModalLayout } from 'index';

import { CSSItem, CSSItemLabel, CSSItemLabelWithEllipsis } from '../JRCWidgetDatasourceTableEditor.styles';

import styled from 'styled-components';
import { updateTableColumns } from '../utils';
import { Typography } from 'components/JRCTypography/JRCTypography.styles';

export const CSSAlert = styled.button`
    border: 1px dashed ${(props) => props.theme.color.orange};
    padding: ${(props) => props.theme.space.sm}px;
    border-radius: ${(props) => props.theme.space.sm}px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 100%;
    margin-top: ${(props) => props.theme.space.sm}px;
`;

export const CSSWrapper = styled.div`
    display: flex;
    flex-direction: row;
`;

export const CSSModel = styled.div`
    flex: 1;
`;

export const WidgetDatasourceModelViewChanges = ({
    model,
    excelHeaders,
    onChange,
}: {
    model: WidgetTableColumn[];
    excelHeaders: string[] | undefined;
    onChange: (model: WidgetTableColumn[]) => void;
}) => {
    const intl = useIntl();
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const [isModelDiff, setIsModelDiff] = useState<boolean>(false);
    const [localModel] = useState<WidgetTableColumn[]>(model);

    const handleModelUpdate = () => {
        if (!excelHeaders) {
            return;
        }
        onChange(updateTableColumns(localModel, excelHeaders));
        setIsModalOpen(false);
    };

    useEffect(() => {
        let hasDiff = false;
        if (!excelHeaders) {
            return;
        }

        excelHeaders.forEach((name, index) => {
            if (model[index] && model[index].name !== name) {
                hasDiff = true;
            }
        });

        if (model.length !== excelHeaders?.length) {
            hasDiff = true;
        }

        setIsModelDiff(hasDiff);
    }, [model, excelHeaders]);

    return (
        <>
            {isModelDiff && (
                <>
                    <CSSAlert onClick={() => setIsModalOpen(true)}>
                        <JRCIcon name={'icon-warning'} color={'orange'} />
                        <div>{intl.formatMessage({ id: 'WIDGET_Datasource_Model_Change' })}</div>
                    </CSSAlert>
                </>
            )}
            {isModelDiff && isModalOpen && (
                <JRCModalLayout
                    enableClickAwayCloseModal={true}
                    open={isModalOpen}
                    closeHandler={() => setIsModalOpen(false)}>
                    <JRCModalContent
                        overflow={'scroll'}
                        title={intl.formatMessage({ id: 'WIDGET_Datasource_Model_Change' })}
                        onClickIconClose={() => setIsModalOpen(false)}>
                        <CSSWrapper>
                            <CSSModel>
                                <Typography size={'l'} weight={'bold'}>
                                    {intl.formatMessage({ id: 'WIDGET_Datasource_Current_Model' })}
                                </Typography>
                                {model.map((el) => {
                                    return (
                                        <CSSItem key={el.name}>
                                            <CSSItemLabel>
                                                <CSSItemLabelWithEllipsis>{el.name}</CSSItemLabelWithEllipsis>
                                            </CSSItemLabel>
                                        </CSSItem>
                                    );
                                })}
                                <JRCButton
                                    label={intl.formatMessage({ id: 'WIDGET_Datasource_Select' })}
                                    variant={'contained'}
                                    onClick={() => onChange(model)}
                                />
                            </CSSModel>
                            <CSSModel>
                                <Typography size={'l'} weight={'bold'}>
                                    {intl.formatMessage({ id: 'WIDGET_Datasource_New_Model' })}
                                </Typography>
                                {excelHeaders &&
                                    excelHeaders.map((el) => {
                                        return (
                                            <CSSItem key={el}>
                                                <CSSItemLabel>
                                                    <CSSItemLabelWithEllipsis>{el}</CSSItemLabelWithEllipsis>
                                                </CSSItemLabel>
                                            </CSSItem>
                                        );
                                    })}
                                <JRCButton
                                    label={intl.formatMessage({ id: 'WIDGET_Datasource_Select' })}
                                    variant={'contained'}
                                    onClick={handleModelUpdate}
                                />
                            </CSSModel>
                        </CSSWrapper>
                    </JRCModalContent>
                </JRCModalLayout>
            )}
        </>
    );
};
